import { render, staticRenderFns } from "./ImpersonateAccount.vue?vue&type=template&id=4ba9a10a&"
import script from "./ImpersonateAccount.vue?vue&type=script&lang=js&"
export * from "./ImpersonateAccount.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonateAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports